import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface UserReducer {
    isLoggedIn: boolean;
    kundeIdUrl: string;
    kundeIdRedirectUrl: string;
    mobilbank: boolean;
    channel: string;
    firstName: string;
    lastName: string;
    name: string;
    email: string;
    phone: string;
    birthDate: string;
    ssn?: string;
    testUser: boolean;
}

export const initialState: UserReducer = {
    isLoggedIn: false,
    kundeIdUrl: '',
    kundeIdRedirectUrl: '',
    mobilbank: false,
    channel: '',
    firstName: '',
    lastName: '',
    name: '',
    email: '',
    phone: '',
    birthDate: '',
    ssn: undefined,
    testUser: false,
};

export const userReducer = (state = initialState, action: AppActions = {} as AppActions): UserReducer => {
    switch (action.type) {
        case actionTypes.FETCH_USER_SESSION_FULFILLED: {
            const { valid, kundeIdUrl, kundeIdRedirectUrl, mobilbank, kanal } = action.payload;
            return {
                ...state,
                isLoggedIn: valid,
                kundeIdUrl,
                kundeIdRedirectUrl,
                mobilbank: mobilbank || state.mobilbank,
                channel: kanal,
            };
        }
        case actionTypes.FETCH_USER_CONTEXT_FULFILLED: {
            const { fornavn, etternavn, epost, telefon, foedselsdato, foedselsnummer } = action.payload;
            return {
                ...state,
                firstName: fornavn || '',
                lastName: etternavn || '',
                name: `${fornavn} ${etternavn}` || '',
                email: epost,
                phone: telefon,
                birthDate: foedselsdato,
                ssn: foedselsnummer,
            };
        }
        case actionTypes.FETCH_TEST_USER_TOGGLE_FULFILLED: {
            const testUser = action.payload;
            return {
                ...state,
                testUser,
            };
        }

        default:
            return state;
    }
};
